import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const serviceName = 'summarizer';
export const summarizerServiceEventType = (entity, eventName) => eventType(serviceName, entity, eventName);
export const SummarizerServiceEventBaseSchema = EventBaseSchema.merge(z.object({
    type: summarizerServiceEventType(),
}));
